<template>
  <svg width="20" height="23" viewBox="0 0 20 23" xmlns="http://www.w3.org/2000/svg">
    <rect x="8" width="4" height="23" rx="2" />
    <rect x="16" y="6" width="4" height="17" rx="2" />
    <rect y="12" width="4" height="11" rx="2" />
  </svg>
</template>
